import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { keys } from "../config/keys";

const StandaloneHeader = ({ title }) => {
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get("returnUrl");
  const fallbackReturnUrl = keys.CLIENT_ORIGIN ? `${keys.CLIENT_ORIGIN}/dashboard` : "/dashboard";

  return (
    <header id="header" className="header fixed-top d-flex align-items-center standalone-header">
      <div className="d-flex align-items-center justify-content-between w-100 pe-3">
        <div className="d-flex align-items-center">
          <Link to="/dashboard" className="logo d-flex align-items-center me-3">
            <img src="/assets/img/logo.png" alt="CompCheck" />
            <span className="d-none d-lg-block">CompCheck.io</span>
          </Link>
          {title ? (
            <span className="d-none d-md-inline text-muted" style={{ fontSize: "14px" }}>
              / {title}
            </span>
          ) : null}
        </div>
        <a href={returnUrl || fallbackReturnUrl} className="btn btn-primary btn-sm">
          <i className="bi bi-arrow-left me-1" />
          Back to app
        </a>
      </div>
    </header>
  );
};

export default StandaloneHeader;
